require('./bootstrap');
require('./form');
require('./utilities');
require('./file-upload');
require('./confirmation-modals');
